import axios from 'axios';

/**
 * @typedef {Object} SellerOnboardingConfig
 * @property {string} stateUrl
 * @property {string} loginUrl
 * @property {string} registerUrl
 * @property {string} completeUrl
 */

function configureHttpDefaults() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    if (csrfToken) {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    }
}

/**
 * @param {SellerOnboardingConfig} config
 */
export function createSellerOnboardingApi(config) {
    configureHttpDefaults();

    return {
        async loadState() {
            const response = await axios.get(config.stateUrl);

            return response.data;
        },
        async submitProfile(mode, payload) {
            const url = mode === 'login' ? config.loginUrl : config.registerUrl;
            const response = await axios.post(url, payload);

            return response.data;
        },
        async complete(payload) {
            const response = await axios.post(config.completeUrl, payload);

            return response.data;
        },
    };
}
